const hasLocalStorage = isLocalStorageSupported();
const currentScope = window.context?.scope || "";

export function isLocalStorageSupported(): boolean {
	if (typeof window === "undefined") return false;
	try {
		return typeof window.localStorage !== "undefined";
	} catch {
		return false;
	}
}

export function setLocalStorageItem(key: string, value: any, expiry?: Date): void {
	if (!hasLocalStorage) return;
	if (!expiry) {
		window.localStorage.setItem(key, JSON.stringify({ value: value, scope: currentScope }));
	} else {
		window.localStorage.setItem(key, JSON.stringify({ value: value, scope: currentScope, expiry: expiry.getTime() }));
	}
}

export function getLocalStorageItem<T>(key: string): T | null {
	if (!hasLocalStorage) return null;
	const item = window.localStorage.getItem(key);
	if (!item) return null;
	let parsedItem: any;
	try {
		parsedItem = JSON.parse(item);
	} catch {
		window.localStorage.removeItem(key); // optional cleanup
		return null;
	}

	const isExpired = (expiry?: number): boolean => {
		return typeof expiry === "number" && new Date().getTime() > expiry;
	};

	if (parsedItem.scope && parsedItem.scope !== currentScope) {
		window.localStorage.removeItem(key);
		return null;
	}
	if (isExpired(parsedItem.expiry)) {
		window.localStorage.removeItem(key);
		return null;
	}
	return parsedItem.value as T;
}

export function removeLocalStorageItem(key: string): void {
	if (!hasLocalStorage) return;
	window.localStorage.removeItem(key);
}
